
import VehicleDocuments from './containers/VehicleDocuments';

export default VehicleDocuments;
export {uiDataVehicleDocuments, serverDataVehicleDocuments} from './reducers/VehicleDocuments';

